/* eslint-disable react-hooks/exhaustive-deps */
import { TableNumber } from "components"
import moment from "moment"
import { APPROVAL } from "pages/Sales/Register/utils/vars"
import { Fragment } from "react"
import { useDropdownEmployee } from "../../CustomerOrder/utils/hooks/useDropdownEmployee"
import { ReturnItemsList } from "../../ReturnItems/utils/hooks"
import { FilterApprovalReturnItems } from "../types"
import { ApproveAction } from "./ApproveAction"

type RowApproveReturnItemProps = {
  pagination: FilterApprovalReturnItems
  employees: ReturnType<typeof useDropdownEmployee>["dropdown"]
  data: ReturnItemsList
  index: number
}

export function RowApproveInvoice({
  pagination,
  employees,
  data,
  index
}: RowApproveReturnItemProps) {
  return (
    <Fragment>
      <tr key={index}>
        <td>
          {TableNumber({
            pageCurrent: pagination?.page,
            dataLength: pagination?.size!,
            index: index,
            limit: pagination?.limit,
            totalData: pagination?.total
          })}
        </td>
        <td>
          <ApproveAction employees={employees} data={data} />
        </td>
        <td>{data.trx_code}</td>
        <td>{moment(data.transaction_date).format("DD/MM/YYYY")}</td>
        <td>{data.customer_name}</td>
        <td>{data.trx_invoice_code}</td>
        <td>{data.location_name}</td>
        <td>{data?.memo}</td>
        <td>{APPROVAL[data.approve_status]}</td>
        <td>
          {data?.approve_date
            ? moment(data.approve_date).format("DD/MM/YYYY")
            : ""}
        </td>
      </tr>
    </Fragment>
  )
}
